// extracted by mini-css-extract-plugin
module.exports = {"patient_insurance":"InsuranceCoverageForms_patient_insurance__3hop9","actions":"InsuranceCoverageForms_actions__20Ye5"};